import { useQuery } from "react-query";
import http from "infra/http";
import { ItemCotado } from "../typings";

function useItensCotados(id?: string) {
  return useQuery([`/v1/orcamento/${id}/items`], async () => {
    const { data } = await http.get<ItemCotado[]>(`/v1/orcamento/${id}/items`);

    return data;
  });
}

export default useItensCotados;
